module.exports = __webpack_public_path__ + "img/warning.0b8245bd.png";